import React, { ReactElement } from 'react';
import NoNotificationImg from './NoNotification.jpg';
import { useTranslation } from 'react-i18next';
import { MessageContainer, NoNotificationImage } from './index.elements';

const NoNotifications = (): ReactElement => {
  const { t } = useTranslation(['fpns']);

  return (
    <MessageContainer>
      <NoNotificationImage src={NoNotificationImg} alt="No Notifications" />
      <p>{t('no_notifications_to_display')}</p>
    </MessageContainer>
  );
};

export default NoNotifications;
